import { set, addDays, subDays, format } from 'date-fns';
import { FilterDate } from 'src/models/FilterMetric';

import FORMAT_QUERY_STRING from 'src/constants/dateFormatQueryString';

const getInitialFilterDateState = (): FilterDate => {
  const presentDate = new Date();

  // set present date time to 05:00:00
  const presentDateWithCustomTime = set(presentDate, {
    hours: 5,
    minutes: 0,
    seconds: 0,
  });

  return {
    range: {
      id: 'range',
      description: '',
      startDate: '',
      endDate: '',
    },
    today: {
      id: 'today',
      description: 'Hoy',
      startDate: format(presentDateWithCustomTime, `${FORMAT_QUERY_STRING}`),
      endDate: format(
        addDays(presentDateWithCustomTime, 1),
        `${FORMAT_QUERY_STRING}`,
      ),
    },
    yerterday: {
      id: 'yerterday',
      description: 'Ayer',
      startDate: format(
        subDays(presentDateWithCustomTime, 1),
        FORMAT_QUERY_STRING,
      ),
      endDate: format(presentDateWithCustomTime, FORMAT_QUERY_STRING),
    },
    sevenDaysAgo: {
      id: 'sevenDaysAgo',
      description: '7 días',
      startDate: format(
        subDays(presentDateWithCustomTime, 7),
        FORMAT_QUERY_STRING,
      ),
      endDate: format(
        addDays(presentDateWithCustomTime, 1),
        FORMAT_QUERY_STRING,
      ),
    },
    fifteenDaysAgo: {
      id: 'fifteenDaysAgo',
      description: '15 días',
      startDate: format(
        subDays(presentDateWithCustomTime, 15),
        FORMAT_QUERY_STRING,
      ),
      endDate: format(
        addDays(presentDateWithCustomTime, 1),
        FORMAT_QUERY_STRING,
      ),
    },
    thirtyDaysAgo: {
      id: 'thirtyDaysAgo',
      description: '30 días',
      startDate: format(
        subDays(presentDateWithCustomTime, 30),
        FORMAT_QUERY_STRING,
      ),
      endDate: format(
        addDays(presentDateWithCustomTime, 1),
        FORMAT_QUERY_STRING,
      ),
    },
  };
};

export default getInitialFilterDateState;
